// Server
const subDirForNavigation = '/sparepart360/';
// mine local
// const baseURL = 'http://192.168.10.71/RehbarSocietyBackend/api';
// Mine
// const baseURL = 'http://localhost/RehbarSocietyBackend/api';
export default subDirForNavigation;
